import { constants } from "@newsela/angelou";

const greyDark = constants.colors.ui.neutral[600];
const blue = constants.colors.brand.blue[500];

export const listContainerCss = {
  display: "flex",
  flexDirection: "column",
  margin: 0,
  padding: 0,
};

export const instructionsCss = {
  fontSize: "1.125rem",
  lineHeight: "178%",
  color: greyDark,
  fontWeight: "normal",
  margin: "0 0 16px 0",
};

export const activityOptionLabelCss = {
  marginRight: "8px",
  "text-align": "left",
  flex: "1",
};

export const iconBaseCss = {
  marginRight: "8px",
  width: "24px",
  marginTop: "2px",
  fill: "transparent",
};

export const draftIconCss = {
  ...iconBaseCss,
  "path[stroke]": {
    stroke: blue,
  },
  "path[fill]": {
    fill: blue,
  },
};

export const submittedIconCss = {
  ...iconBaseCss,
  "circle[fill]": {
    fill: "transparent",
  },
  "path[stroke], circle[stroke]": {
    stroke: blue,
  },
};
